import generateStyles from './generateStyles';

export default () => ({
    '&.slick-prev': {
        ...generateStyles('left'),
    },
});
